import React, { useEffect, useCallback, useState, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import './VideoCard.css';
import { selectApp, setCurrentWatch, setLastFocusedElement } from "../../app/appSlice";
import { useHistory } from "react-router-dom";
import imagePlaceholder from '../../assets/imagePlaceholder.png';

const EpisodeCard = forwardRef(({ episode }, ref) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [thumbnailUrl, setThumbnailUrl] = useState(imagePlaceholder);
  const { page, lastFocusedElement } = useSelector(selectApp);
  const [visible, setVisible] = useState(false);
  const [animate, setAnimate] = useState(false);
  const delay = useState(() => Math.floor(Math.random() * 400) + 100)[0];

  useEffect(() => {
    const img = new Image();
    img.onload = function () {
      setThumbnailUrl(img.width < 1280 || img.height < 155 
        ? `https://i.ytimg.com/vi/${episode.video_id}/mqdefault.jpg` 
        : episode.thumbnail_url);
    };
    img.onerror = function () {
      setThumbnailUrl(`https://i.ytimg.com/vi/${episode.video_id}/mqdefault.jpg`);
    };
    img.src = episode.thumbnail_url;
  }, [episode.thumbnail_url, episode.video_id]);

  const goToWatch = useCallback((selectedEpisode) => {
    
    // Get slideview-row scroll x value
    const seriesListEl = document.activeElement.closest(".category-row")?.querySelector(".series-list");
    let x = 0;
    if(seriesListEl) {
      const matrix = window.getComputedStyle(seriesListEl).transform;
    
      if (matrix && matrix !== "none") {
        const values = matrix.match(/matrix\(([^)]+)\)/);
        if (values && values[1]) {
          const parts = values[1].split(", ");
          x = parseFloat(parts[4]); // This is the translateX value
        }
      }
    }
    const series_id = page.name === "Home" ? episode.series_id : selectedEpisode.series_id;
    dispatch(setCurrentWatch({ series_id: series_id, selectedEpisode, isPlaying: false, isPlayerReady: false }));
    dispatch(setLastFocusedElement({id: document.activeElement.id, scrollTop: document.activeElement.scrollTop, scrollLeft: x, prevPage: page.name  }));
    history.push(`/watch/${series_id}/${selectedEpisode.episode_id}`);

  }, [dispatch, history, episode, page.name]);

  useEffect(() => {
    if(!lastFocusedElement)
      setAnimate(true);

    const timeout = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timeout);
  
  // eslint-disable-next-line  
  }, [delay]);

  return (
    <div 
      id={episode.video_id}
      ref={ref} // Use the forwarded ref here
      className="episodeCard focusable" 
      style={{
        opacity: visible ? 0.7 : 0,
        transform: visible && animate ? 'translateY(0)' : 'translateY(10px)',
        // transition: `opacity 0.2s ease-out ${delay}ms, transform 0.2s ease-out ${delay}ms`,
      }}
      data-title={episode.episode_title} 
      data-videoid={episode.video_id}
      onClick={() => goToWatch(episode)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.keyCode === 13) {
          goToWatch(episode);
        }
      }}
      tabIndex={0}
    >
      {(episode.is_series) && (
        <div className="episodeTag">
          {episode.series_title}
        </div>
      )}
      <img 
        src={thumbnailUrl} 
        alt={episode.episode_title} 
        loading="lazy" 
      />
    </div>
  );
});

export default React.memo(EpisodeCard);
